/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * @example
 *     {}
 */
export interface PublishedVcdmJsonSchemaFetchRequest {}
